module.exports = __webpack_public_path__ + "img/upgrade-issuer.b772f027.svg";